<template>
  <p>Te has suscrito exitósamente al plan</p>
</template>
